import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=1dad827f&"
import script from "./validate.vue?vue&type=script&lang=js&"
export * from "./validate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dad827f')) {
      api.createRecord('1dad827f', component.options)
    } else {
      api.reload('1dad827f', component.options)
    }
    module.hot.accept("./validate.vue?vue&type=template&id=1dad827f&", function () {
      api.rerender('1dad827f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/validate.vue"
export default component.exports